import React, { useContext, useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { ReactComponent as SuccesspaymentIcon } from "../../../../assets/icons/success_payment.svg";
import { LanguageContext } from "../../../../context/LanguageContext";
import {
  InnerWrapper,
  ReceiptPage,
  TitleAndActionBox,
} from "./../../../common";
import { HeadingText, ParagraphText, UBButton } from "../../../../Libraries";
import { SaleBookNonIdeal } from "../../../common/NewNonIdeal";
import withObservables from "@nozbe/with-observables";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { isDemoMode } from "../../../../utils/demoEnviornment";
import { observeInvoicesById } from "../../../../database/helpers/invoice";
import saleBookStyles from "../styles.module.css";
import styles from "./styles.module.css";
import { CheckmarkGreenIcon } from "../../../../assets/icons/icon";
import { handleDownloadInvoice } from "../../NewInvoiceBook/invoiceBookUtils";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { useAuthContext } from "../../../../context/AuthContext";

const PaymentSuccess = ({ currentTransaction }) => {
  currentTransaction = currentTransaction.length
    ? currentTransaction[0]
    : currentTransaction;
  const navigate = useNavigate();
  const location = useLocation();
  const { business,user } = useAuthContext();
  const [I18n] = useContext(LanguageContext);
  const [notFound, setNotFound] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { showSnackbar } = useSnackbar();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "N") {
        event.preventDefault();
        newSale();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (currentTransaction.length === 0) setNotFound(true);
  }, []);

  useEffect(() => {
    if (location.state?.showDemoModal && isDemoMode()) {
      const timer = setTimeout(() => setShowDemoModal(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  const newSale = () => {
    triggerLogEvent(analytics, "pos_next_sale");
    navigate(`/SaleBook`, { replace: true });
  };

  const handleDownload = async () => {
    setIsLoading(true);
    try {
      await handleDownloadInvoice(
        currentTransaction,
        business,
        (error) => {
          if (error) {
            if (!user?.phone_number) {
              showSnackbar({
                message: I18n.report_download_is_not_available_yet,
                severity: "error",
              });
            } else {
              showSnackbar({
                message: I18n.error_downloading_report,
                severity: "error",
              });
            }
            setIsLoading(false);
            return;
          }

          setIsLoading(false);
          showSnackbar({
            message: I18n.successfully_download_invoice,
            severity: "success",
          });
        },
        navigate,
        "Rupin Sale Invoice",
      );
      triggerLogEvent(analytics, "pos_option_download");
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box className={saleBookStyles.SaleBookWrapper}>
      <TitleAndActionBox
        data={{
          title: "transaction_details",
          isBack: true,
          id: "transaction_details",
        }}
      ></TitleAndActionBox>
      <InnerWrapper
        className={`innerWrapper oneColumnWithBreadcrum ${saleBookStyles.transSuccess}`}
      >
        <Box className={styles.content}>
          {!notFound ? (
            <Grid container className={styles.gridContainer}>
              <Grid item md={4}>
                <Box className={styles.iconWrap}>
                  <CheckmarkGreenIcon width={60} height={60} />
                </Box>
                <HeadingText
                  tag="h2"
                  className={"textCenter fontSize24 fontWeight500 newFontColor"}
                >
                  {I18n.payment_successfully}
                </HeadingText>
                <div className={styles.spacer20} />
                <ParagraphText
                  align="center"
                  className="fontSize16 newLightColor"
                >
                  {I18n.amount_paid}{" "}
                  <span className="textLowercase">
                    {currentTransaction?._raw?.method === "cash"
                      ? I18n.cash_small
                      : currentTransaction?._raw?.method === "online"
                        ? I18n.online_payment
                        : I18n.udhaar}{" "}
                  </span>
                  Rs.{" "}
                  {formatNum(
                    currentTransaction?.method === "cash"
                      ? currentTransaction?.change_amount
                      : currentTransaction?.amount,
                  ) ?? 0}
                </ParagraphText>
                <div className={styles.spacer8} />
                <HeadingText
                  tag="h2"
                  className={"fontSize28 fontWeight500 newFontColor textCenter"}
                  align="center"
                >
                  {I18n.change} Rs.{" "}
                  {currentTransaction?._raw?.method === "cash"
                    ? (formatNum(
                        currentTransaction?._raw?.change_amount -
                          currentTransaction?._raw?.amount,
                      ) ?? 0)
                    : 0}
                </HeadingText>
                <UBButton
                  id="new_sale_pos"
                  title={`${I18n.new_sale} (SHIFT + N)`}
                  className={`${styles.newSaleBtn} ubPrimaryButton fontSize14 textUppercase`}
                  onClick={newSale}
                />
                <Box className={styles.actionBoxWrapper}>
                  <ReceiptPage
                    actionVariant="success"
                    isNotShowReceipt={true}
                    customPrintBtn={I18n.print_recipt}
                    onInvoiceDownload={handleDownload}
                    invoiceBtnTitle={I18n.download_invoice}
                    receiptDownloadTitle={I18n.download_receipt}
                    invoiceId={currentTransaction?.id ?? ""}
                    handlePrintLogEvent={() =>
                      triggerLogEvent(analytics, "pos_receipt_printed")
                    }
                    downloadLoading={isLoading}
                    spinnerColor="newFontColor"
                    hideActionIcons
                    handleDownloadLogEvent={() =>
                      triggerLogEvent(analytics, "pos_receipt_downloaded")
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          ) : (
            <SaleBookNonIdeal title="Not Found Transaction" />
          )}
        </Box>
      </InnerWrapper>
    </Box>
  );
};

const enhance = withObservables(["transactionId"], ({ transactionId }) => ({
  currentTransaction: observeInvoicesById(transactionId ? transactionId : ""),
}));

export default enhance(PaymentSuccess);
